import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
import { getFullUrl } from 'hubspot-url-utils';
import { MARKETING_STARTER } from 'self-service-api/constants/UpgradeProducts';
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import { getSource } from 'ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySource';
// @ts-expect-error upstream is not migrated to TypeScript
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import MultipleOfferCheckoutButton from '../_core/checkout/MultipleOfferCheckoutButton';
import { getCanViewNewSeats } from '../_core/common/eligibility/getCanViewNewSeats';
import { navigateTo } from '../_core/common/navigation/url';
import PricingPageInterstitialBuyNowButton from '../_core/interstitial/PricingPageInterstitialBuyNowButton';
import { mapPurchaseMotionApiName } from '../ums/utils';
import { UIBuyNowButton } from './UIBuyNowButton/UIBuyNowButton';
import { jsx as _jsx } from "react/jsx-runtime";
const UICheckoutButton = props => {
  const {
    'data-selenium-id': dataSeleniumId,
    'data-test-id': dataTestId,
    offerProductConfigurations,
    nonRecurringProductConfigurations,
    productConfigurations,
    requestedProducts,
    terms,
    upgradeData,
    children,
    className,
    disabled,
    use = 'primary',
    shouldShowErrorAlert
  } = props;
  const [hasSeatsAccess, setHasSeatsAccess] = useState(props.canViewNewSeats);
  const {
    app,
    screen,
    uniqueId,
    upgradeProduct
  } = upgradeData;
  const apiName = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  const handleInterstitialCheckoutClick = () => {
    const queryString = stringify({
      products: [`${apiName}_1`]
    });
    const interstitialUrl = `${getFullUrl('app')}/pricing/${PortalIdParser.get()}/interstitial?${queryString}`;
    navigateTo(interstitialUrl);
  };
  useEffect(() => {
    if (props.canViewNewSeats === undefined) {
      void getCanViewNewSeats().then(setHasSeatsAccess);
    } else {
      setHasSeatsAccess(props.canViewNewSeats);
    }
  }, [props.canViewNewSeats]);
  if (requestedProducts !== null && requestedProducts !== void 0 && requestedProducts.length) {
    const apiNames = requestedProducts.map(({
      productApiName
    }) => productApiName);
    return /*#__PURE__*/_jsx(UIBuyNowButton, Object.assign({
      shouldDisplayAlertOnFailure: shouldShowErrorAlert,
      requestedProducts: requestedProducts,
      terms: terms,
      trackingProperties: {
        apiNames,
        screen,
        uniqueBuyNowUseCase: uniqueId,
        upgradeReferralSource: upgradeData.upgradeSource
      },
      className: className,
      use: use,
      disabled: disabled
    }, props));
  }
  if (!offerProductConfigurations || !nonRecurringProductConfigurations || productConfigurations) {
    if (!apiName) {
      const migrationIssueLink = 'https://git.hubteam.com/HubSpot/growth-ebx-planning/issues/539#issuecomment-4926440';
      throw new Error(`productConfigurations and offerId are deprecated. Please follow the steps on ${migrationIssueLink} to migrate your UICheckoutButton props.`);
    }
    if (hasSeatsAccess) {
      return /*#__PURE__*/_jsx(PricingPageInterstitialBuyNowButton, {
        onClick: handleInterstitialCheckoutClick,
        upgradeData: upgradeData,
        use: use,
        className: className,
        trackingSource: props.trackingSource,
        location: props.location,
        seleniumId: apiName,
        "data-selenium-id": dataSeleniumId,
        "data-test-id": dataTestId,
        children: children
      });
    }
    return /*#__PURE__*/_jsx(UIBuyNowButton, Object.assign({
      shouldDisplayAlertOnFailure: shouldShowErrorAlert,
      requestedProducts: [{
        productApiName: apiName
      }],
      trackingProperties: {
        apiNames: [apiName],
        screen,
        uniqueBuyNowUseCase: uniqueId,
        upgradeReferralSource: upgradeData.upgradeSource
      },
      className: className,
      use: use,
      disabled: disabled
    }, props));
  }

  //Temp check to track marketing-starter
  if (upgradeProduct === MARKETING_STARTER) {
    Raven.captureException(new Error('Checkout button with Marketing-starter upgradeProduct'), {
      extra: {
        uniqueId,
        app
      }
    });
  }
  upgradeData.source = getSource({
    app,
    screen,
    uniqueId
  }, sourceKeys.CHECKOUT);
  const upgradeDataWithApiName = Object.assign({}, upgradeData, {
    apiName: mapPurchaseMotionApiName(true, upgradeData.upgradeProduct, 'UICheckoutButton', upgradeData.apiName)
  });
  return /*#__PURE__*/_jsx(MultipleOfferCheckoutButton, Object.assign({}, props, {
    upgradeData: upgradeDataWithApiName,
    use: use
  }));
};
export default UICheckoutButton;